/**
 * Award Types - Shared type definitions
 * @package @comp-sys/shared
 */
/**
 * Standard award types used across the system
 */
export var AwardType;
(function (AwardType) {
    AwardType["CHAMPION"] = "CHAMPION";
    AwardType["RUNNER_UP"] = "RUNNER_UP";
    AwardType["THIRD"] = "THIRD";
    AwardType["GOLD"] = "GOLD";
    AwardType["SILVER"] = "SILVER";
    AwardType["BRONZE"] = "BRONZE";
    AwardType["EXCELLENCE"] = "EXCELLENCE";
    AwardType["PARTICIPATION"] = "PARTICIPATION";
    AwardType["SPECIAL"] = "SPECIAL";
})(AwardType || (AwardType = {}));
/**
 * New simplified preset award types
 * Replaces AwardType for unified awards system
 */
export var PresetAwardType;
(function (PresetAwardType) {
    PresetAwardType["CHAMPION"] = "CHAMPION";
    PresetAwardType["RUNNER_UP"] = "RUNNER_UP";
    PresetAwardType["THIRD"] = "THIRD";
    PresetAwardType["FIRST_PRIZE"] = "FIRST_PRIZE";
    PresetAwardType["SECOND_PRIZE"] = "SECOND_PRIZE";
    PresetAwardType["THIRD_PRIZE"] = "THIRD_PRIZE";
    PresetAwardType["BEST_DESIGN"] = "BEST_DESIGN";
})(PresetAwardType || (PresetAwardType = {}));
//# sourceMappingURL=awards.js.map